import React from 'react'
import PropTypes from 'prop-types'

import { compose } from 'recompose'

import { Checkbox, Form, Header, Message, Modal } from 'semantic-ui-react'

import Container from './SettingsModalContainer'
import Enhancer from './SettingsModalEnhancer'

import Button from 'Components/StandardButton'
import FormInputDropdown from 'Components/FormInputDropdown'
import Permissions from 'Components/Permissions'

import * as options from './options'
import { SETTINGS_KEYS } from 'Global/constants'
import { getUserSetting } from 'Global/Helpers/userHelpers'

const SettingsModal = props => {
  const { advisorOptions, close, handleAdditionalAdvisors, handleCheckbox, handleChoice, hasError, isPending, user } = props

  const sortByDefault = getUserSetting(user, SETTINGS_KEYS.SORT_BY) || 'dateOrder'
  const sortOrderDefault = getUserSetting(user, SETTINGS_KEYS.SORT_ORDER) || 'descending'
  const layoutDefault = getUserSetting(user, SETTINGS_KEYS.LAYOUT) || 'gridLayout'
  const ignoreDPDefault = getUserSetting(user, SETTINGS_KEYS.IGNORE_DP_NOTIFICATIONS) === 'true' || false

  return (
    <Modal onClose={close} open={true}>
      <Modal.Header>Settings</Modal.Header>

      <Modal.Content>
        {hasError && <Message content="This wasn&#39;t supposed to happen. Please try again." header="An Error Occured." error />}

        <Header as="h3" content="Global" />
        <Form.Field>
          <label>Default sort by field.</label>
          <Form.Dropdown
            defaultValue={sortByDefault}
            name={SETTINGS_KEYS.SORT_BY}
            onChange={handleChoice}
            options={options.sortBy}
            placeholder={'Sort By'}
            fluid
            selection
          />
        </Form.Field>

        <br />

        <Form.Field>
          <label>Default sort order.</label>
          <Form.Dropdown
            defaultValue={sortOrderDefault}
            name={SETTINGS_KEYS.SORT_ORDER}
            onChange={handleChoice}
            options={options.sortOrder}
            placeholder={'Sort Order'}
            fluid
            selection
          />
        </Form.Field>

        <br />

        <Form.Field>
          <label>Default layout.</label>
          <Form.Dropdown
            defaultValue={layoutDefault}
            name={SETTINGS_KEYS.LAYOUT}
            onChange={handleChoice}
            options={options.layout}
            placeholder={'Layout'}
            fluid
            selection
          />
        </Form.Field>

        <br />

        <Permissions
          permissions="setting.additionalAdvisors"
          render={() => (
            <Form.Field>
              <FormInputDropdown
                error={hasError}
                name={SETTINGS_KEYS.ADDITIONAL_ADVISORS}
                onChange={handleAdditionalAdvisors}
                options={advisorOptions}
                text="See rugs from additional advisors."
                value={user.additionalAdvisors}
              />
              <small>Please reload after changes.</small>
            </Form.Field>
          )}
        />

        <Permissions
          permissions="setting.designerRequestNotifications"
          render={() => (
            <Form.Field>
              <br />
              <br />
              <Checkbox
                defaultChecked={ignoreDPDefault}
                label={`Don't recieve designer picture request notifications.`}
                name={SETTINGS_KEYS.IGNORE_DP_NOTIFICATIONS}
                onChange={handleCheckbox}
                toggle
              />
            </Form.Field>
          )}
        />
      </Modal.Content>

      <Modal.Actions>
        <Button content="Save & Close" icon={'x'} onClick={close} pending={isPending} />
      </Modal.Actions>
    </Modal>
  )
}

SettingsModal.propTypes = {
  advisorOptions: PropTypes.array.isRequired,
  close: PropTypes.func.isRequired,
  handleAdditionalAdvisors: PropTypes.func.isRequired,
  handleCheckbox: PropTypes.func.isRequired,
  handleChoice: PropTypes.func.isRequired,
  hasError: PropTypes.bool.isRequired,
  isPending: PropTypes.bool.isRequired,
  setAdditionalAdvisors: PropTypes.func.isRequired,
  setSetting: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
}

const composed = compose(
  Enhancer,
  Container,
)

export default composed(SettingsModal)
